import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

function AppBootstrap() {
  React.useLayoutEffect(() => {
    const fallbackHost = document.querySelector('[data-seo-fallback-host="true"]');
    fallbackHost?.remove();

    window.clearTimeout(window.__seoFallbackTimeout);
    delete window.__seoFallbackTimeout;

    document.documentElement.classList.remove("app-loading");
    document.documentElement.classList.add("app-ready");
  }, []);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppBootstrap />
  </React.StrictMode>,
);
